'use client';

import AuralizationPlayer from '@/components/audio/AuralizationPlayer';
import { useToolAuralization } from '@/components/tools/useToolAuralization';
import type { RoomAcoustics } from '@/lib/audio/types';

interface MultiProps {
  states: Record<string, RoomAcoustics>;
  stateButtons: { id: string; label: string }[];
  defaultState?: string;
  idleHint?: string;
}

/** Multi-state tool auralization (Pure / Bare / Panel / …). */
export function ToolMultiAuralization({
  states,
  stateButtons,
  defaultState,
  idleHint,
}: MultiProps) {
  const api = useToolAuralization(states, defaultState ?? stateButtons[0]?.id);
  // `data-seo="audio"`: the page registry's "audio" feature, proven to the
  // crawl gate (web/scripts/seo/crawl-rules.mjs FEATURE_MARKERS).
  return (
    <div data-seo="audio">
      {api.hasData ? (
        <AuralizationPlayer api={api} states={stateButtons} idleHint={idleHint ?? ''} />
      ) : (
        <p className="text-body-sm text-[var(--rt-ink-dim)]">Audio preview needs a frequency response to build.</p>
      )}
    </div>
  );
}
